import {useDispatch, useSelector} from "react-redux";
import useOverwolfInterop, { isOnOWKey } from "@/hooks/useOverwolfInterop";
import {logout} from "@/redux/auth/authActions";
import {useActiveWallet, useDisconnect} from "thirdweb/react";
import {Wallet} from "thirdweb/wallets";
import getConfig from "@/utils/getConfig";
import { TokensApi } from "@devour/client";
import {IStore} from "@/redux/defaultStore";

/**
 * Depending on where this hook is initialized, the `useActiveWallet()` may or may not be set.
 * Optionally pass the wallet instance to the `devourLogout()` function.
 */
export default function useOnLogout() {
    const { sendMessageToOW } = useOverwolfInterop();
    const dispatch = useDispatch();
    const { disconnect } = useDisconnect();
    const connectedWallet = useActiveWallet();
    const fullToken = useSelector((store: IStore) => store.authStore.fullToken);

    async function devourLogout(instancedWallet?: Wallet) {
        // Logout initiated
        try {
            if (fullToken) {
                try {
                    await new TokensApi(getConfig()).deleteToken({
                        tokenBody: {
                            token: fullToken.token,
                        },
                    });
                } catch (error) {
                    // Log error but continue with logout process
                    console.error("Failed to delete token from server:", error);
                }
            }

            dispatch(logout());
            sendMessageToOW({type: "de:logout"});

            if (instancedWallet) {
                try {
                    // console.log("disconnect instanced wallet", instancedWallet);
                    await disconnect(instancedWallet);
                } catch (error) {
                    console.error("Failed to disconnect instanced wallet:", error);
                }
            }
            if (connectedWallet) {
                try {
                    // console.log("disconnect connected wallet", connectedWallet);
                    await disconnect(connectedWallet);
                } catch (error) {
                    console.error("Failed to disconnect connected wallet:", error);
                }
            }

            // Delete storage data
            const isOnOverwolf = sessionStorage.getItem(isOnOWKey);
            localStorage.clear();
            sessionStorage.clear();
            if (isOnOverwolf) {
                sessionStorage.setItem(isOnOWKey, isOnOverwolf);
            }
        } catch (error) {
            console.error("Failed to logout:", error);
            // Re-throw to let calling code handle if needed
            throw new Error("Failed to logout");
        }
    }

    return {devourLogout};
}
